var MaintenanceModelService = function ($q) {
    var Model = function () {
        this.maintenanceIntervals = [];
    };

    Model.prototype.resetModel = function () {
        this.maintenanceIntervals = [];
        _.unset(this, 'factoryRequiredServices');
        _.unset(this, 'dealerRecommendedServices');
    };

    //setMaintenanceIntervals
    //
    //@param {number} period in miles between maintenance intervals
    //@param {number} current vehicle odoveter value (mileage)
    //
    //@return {array} maintenance intervals
    //
    //@description
    //Buids the maintenance intervals according to the passed maintenance period
    //and current vehicle odometer value
    Model.prototype.setMaintenanceIntervals = function (maintenancePeriod, currentOdometerValue, enrollmentMileage, autoSelect) {
        //check if the required parameters is passed
        if (!maintenancePeriod || !currentOdometerValue) {
            throw new Error('maintenance period or current odometer value is not set');
        }
        if (_.isUndefined(autoSelect)) autoSelect = true;

        var maintenanceIntervals = [];
        // it is required to build maintenace services intervals
        // according to own vehicle services period up to
        // 1000000 miles
        var intervalsCount = 1000000 / maintenancePeriod + 1;
        //if less then first period -> select first period.
        var autoSelectId = Math.round((currentOdometerValue - (+enrollmentMileage)) / maintenancePeriod) || (enrollmentMileage ? 0 : 1);
        //susdev-941: if currentOdometerValue < enrollmentMileage, then select first period
        autoSelectId = autoSelectId < 0 ? 0 : autoSelectId;

        for (var i = enrollmentMileage ? 0 : 1; i < intervalsCount; i++) {
            var currentIntervalMileage = i * maintenancePeriod + +enrollmentMileage;
            maintenanceIntervals.push({
                index: i - enrollmentMileage ? 0 : 1,
                mileage: currentIntervalMileage,
                displayMileage: (currentIntervalMileage / 1000) + "K",
                selected: autoSelect && autoSelectId === i
            });
        }
        this.maintenanceIntervals = maintenanceIntervals;
        return maintenanceIntervals;
    };
    //updateSelectedMaintenanceInterval
    //
    //@return void
    //
    //@description
    //Updates selected Maintenance Interval according to passed mileage
    Model.prototype.updateSelectedMaintenanceInterval = function (odometer) {
        this.maintenanceIntervals.forEach(function (el, index, a) {
            if (index === a.length - 1 && el.mileage <= odometer)
                el.selected = true;
            else
                el.selected = el.mileage <= odometer && a[index + 1].mileage > odometer;
        })
    };
    //getMaintenanceIntervals
    //
    //@return {array} maintenance intervals
    //
    //@description
    //Gets current mentainance intervals from model data
    Model.prototype.getMaintenanceIntervals = function () {
        return this.maintenanceIntervals;
    };
    //getSelectedMaintenanceInterval
    //
    //@param {array} maintenance intervals
    //
    //@return {object} selected maintenance interval
    //
    //@description
    //gets selected meintenance interval from given array
    Model.prototype.getSelectedMaintenanceInterval = function (maintenanceIntervals) {
        return _.find(maintenanceIntervals, { selected: true })
    };
    //resolveFactoryRequiredServices
    //
    //@param {object} vehicle instance to request maintenance services
    //@param {number} mileage
    //@param {boolean} force request
    //
    //@description
    //Get the factory required services according to the passed mileage if this
    //is a first request or force is true data will be fetched from server
    //otherwice data will be got from the model storage
    Model.prototype.resolveFactoryRequiredServices = function (vehicle, mileage, force) {
        var deferred = $q.defer();
        if (this.factoryRequiredServices && !force) {
            deferred.resolve(this.factoryRequiredServices);
        } else {
            if (vehicle.getDriveTrain() && vehicle.getDriveTrain().resolveFactoryRequiredServices) {
                vehicle.getDriveTrain().resolveFactoryRequiredServices("mileage", mileage).then(function (result) {
                    this.factoryRequiredServices = result;
                    deferred.resolve(result);
                }.bind(this));
            } else {
                vehicle.model.resolveModel().then(function (model) {
                    return model.resolveFactoryRequiredServices("mileage", mileage);
                }).then(function (result) {
                    this.factoryRequiredServices = result;
                    deferred.resolve(result);
                }.bind(this));
            }
        }
        return deferred.promise;
    };
    //resolveDealerRecommendedServices
    //
    //@param {object} vehicle instance to request maintenance services
    //@param {number} mileage
    //@param {boolean} force request
    //
    //@description
    //Get the dealer recommended services according to the passed mileage if this
    //is a first request or force is true data will be fetched from server
    //otherwice data will be got from the model storage
    Model.prototype.resolveDealerRecommendedServices = function (vehicle, mileage, force) {
        var deferred = $q.defer();
        if (this.dealerRecommendedServices && !force) {
            deferred.resolve(this.dealerRecommendedServices);
        } else {
            if (vehicle.getDriveTrain().resolveDealerRecommendedServices) {
                vehicle.getDriveTrain().resolveDealerRecommendedServices("mileage", mileage).then(function (result) {
                    this.dealerRecommendedServices = result;
                    deferred.resolve(result);
                }.bind(this));
            } else {
                vehicle.model.resolveModel().then(function (model) {
                    return model.resolveDealerRecommendedServices("mileage", mileage);
                }).then(function (result) {
                    this.dealerRecommendedServices = result;
                    deferred.resolve(result);
                }.bind(this));
            }
        }

        return deferred.promise;
    };

    return new Model();
};

MaintenanceModelService.$inject = ['$q'];

module.exports = MaintenanceModelService;
